export default "__VITE_ASSET__BTockD6n__"